import * as $ from 'jquery';
import {closeSearchOverlay} from './NavSearchFormUtility';
import {hideContactInfo} from '../FlyOut/ContactAndSocialShareFlyOutController';

export function createMobileNav() {
  $('#mobileNav').mmenu({
    classNames: {
      selected: 'active',
    },
    header: {
      add: true,
      title: '<a class="homeLink" href="/"><span class="glyphicon glyphicon-home" aria-hidden="true"></span> FAULHABER</a>',
      update: true,
    },
  });

  $('#mobileToggle').appendTo($('body')).on('click', () => {
    if ($('html').hasClass('mm-opened')) {
      closeResponsiveMenu();
    } else {
      openResponsiveMenu();
    }
  });
}

export function openResponsiveMenu() {
  $('#mobileNav').trigger('open.mm');
  closeSearchOverlay();
  hideContactInfo();
}

export function closeResponsiveMenu() {
  $('#mobileNav').trigger('close.mm');
}
